import { Theme } from '@mui/material';
import { TableSizeType } from '../../types/reports';

export const getTableBorderColor = (theme: Theme, type: TableSizeType) =>
  type === 'compact' ? theme.palette.darkerLightGrey.main : '#EDEEEF';

/**
 * Returns the padding for the table cells in px
 */
export const getTableCellPadding = (type: TableSizeType) => ({
  x: type === 'compact' ? 16 : 32,
  y: 16,
});
